export default "__VITE_ASSET__WiKN4bU4__"